"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultLoggers = getDefaultLoggers;
exports["default"] = void 0;

var _analyticsService = _interopRequireDefault(require("./analytics-service"));

var _googleTagManagerLogger = _interopRequireDefault(require("./loggers/google-tag-manager-logger"));

var _googleTagManagerLoggerShell = _interopRequireDefault(require("./loggers/google-tag-manager-logger-shell"));

var _datadogLogger = _interopRequireDefault(require("./loggers/datadog-logger"));

var _faasLogger = _interopRequireDefault(require("./loggers/faas-logger"));

var _default = _analyticsService["default"];
exports["default"] = _default;

function getDefaultLoggers() {
  var useShellVariants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return [useShellVariants ? _googleTagManagerLoggerShell["default"] : _googleTagManagerLogger["default"], _datadogLogger["default"], _faasLogger["default"]];
}